<div id="search-add-container">
  <app-watchlist-ticker-search
    (tickersSearchResult)="addSearchedTicker($event)"
  ></app-watchlist-ticker-search>
  <div class="table-container">
    <nz-table
      data-test="new-watchlist-grid"
      #watchlistTable
      class="new-watchlist-grid"
      [nzData]="currentGridTickers"
      nzSize="small"
      nzShowPagination="false"
      nzBordered
      [nzScroll]="{ y: '250px', x: 'auto' }"
      [nzFooter]="selectedFooter"
    >
      <thead>
        <tr>
          <th
            class="checkbox-sm checkbox-black"
            [nzShowCheckbox]="true"
            [(nzChecked)]="checked"
            [nzIndeterminate]="indeterminate"
            (nzCheckedChange)="onAllChecked($event)"
            nzWidth="28px"
          ></th>
          <th nzWidth="164px">
            VA Ticker
          </th>
          <th nzWidth="164px">
            BBG Ticker
          </th>
          <th nzWidth="auto">Company</th>
        </tr>
      </thead>
      <tbody>
        <tr
          *ngFor="let data of currentGridTickers"
          [ngClass]="{
            'error-row': data.hasError
          }"
        >
          <ng-container *ngIf="data.hasError">
            <td
              class="checkbox-sm checkbox-black"
              [nzShowCheckbox]="true"
              [nzChecked]="deleteSelectedTickers.has(data.id)"
              (nzCheckedChange)="onItemChecked(data.id, $event)"
              nzWidth="28px"
            ></td>
            <td nzWidth="164px">
              {{ data.ticker }} -
              <span class="error-text">{{ data.errorMsg }}</span>
            </td>
            <td nzWidth="164px">
              Error - <span class="error-text">{{ data.errorMsg }}</span>
            </td>
            <td nzWidth="auto">
              Error - <span class="error-text">{{ data.errorMsg }}</span>
            </td>
          </ng-container>
          <ng-container *ngIf="!data.hasError">
            <td
              class="checkbox-sm checkbox-black"
              [nzShowCheckbox]="true"
              [nzChecked]="deleteSelectedTickers.has(data.id)"
              (nzCheckedChange)="onItemChecked(data.id, $event)"
              nzWidth="28px"
            ></td>
            <td nzWidth="164px">
              <span class="grid-text">
                {{ data.ticker }}
              </span>
            </td>
            <td nzWidth="164px">
              <span class="grid-text">
                {{ data.bbgTicker }}
              </span>
            </td>
            <td nzWidth="auto">
              <span *ngIf="data.name.length <= 28">
                <span class="grid-text">
                  {{ data.name }}
                </span>
              </span>
              <span
                *ngIf="data.name.length > 28"
                [nzTooltipTitle]="data.name"
                nz-tooltip
              >
                <span class="grid-text">
                  {{ data.name }}
                </span>
              </span>
            </td>
          </ng-container>
        </tr>
      </tbody>
      <ng-template #selectedFooter>
        <div
          class="remove-tickers"
          [ngClass]="{ hide: !indeterminate && !checked }"
          (click)="removeTicker()"
        >
          <span>
            <va-icon name="close" class="remove-icon"></va-icon>
            <span>Remove Selected Rows</span>
          </span>
        </div>
      </ng-template>
    </nz-table>
  </div>
</div>
